import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  Block,
  FormGroup,
  DatePicker,
  DataTypeInput
} from '../../components';
import {Form, Col, Row} from 'react-bootstrap';
import {usePropState} from "../../utils";

export function ExtractGeneralForm({formData, getInputProps, disabled, useParentFormRef, ...props}) {
  const { t } = useTranslation();
  const {isValid, isInvalid, errors} = getInputProps("data_type")
  const dataTypesProps = {isValid, isInvalid, errors}
  const [bucket,] = usePropState(props.bucket)

  return (
    <React.Fragment>
      <Block title={t("stream.dataTypes")} {...dataTypesProps} >
        <DataTypeInput {...getInputProps("data_type")} />
      </Block>
      <Block title={t("stream.general")}>
        <Form>
          <Form.Row>
            <FormGroup
              as={Col}
              label={t("stream.name")}
              input="text"
              placeholder="Default"
              text={t("stream.nameText")}
              {...getInputProps("name")}/>
            <FormGroup
              as={Col}
              label="&nbsp;"
              input="text"
              placeholder="root"
              pre={`s3://data-stream-partners-sink/${bucket}/extracts/`}
              {...getInputProps("stream")}/>
          </Form.Row>
          <Form.Row>
            <FormGroup
              as={Col}
              input={DatePicker}
              label={t("stream.startDate")}
              {...getInputProps("start_date")}
              placeholder={t("stream.now")}/>
            <FormGroup
              as={Col}
              label={t("stream.endDate")}
              input={DatePicker}
              {...getInputProps("end_date")}/>
          </Form.Row>
        </Form>
      </Block>
    </React.Fragment>
  )
}

// Extract.propTypes = {}

ExtractGeneralForm.propTypes = {
  formData: PropTypes.object,
  getInputProps: PropTypes.func,
  disabled: PropTypes.bool
}
